// src/admin/AdminRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import Loader from '../components/Loader';

export default function AdminRoute({ children }) {
  const { user, loading } = useApp();
  if (loading) return <Loader fullPage />;
  if (!user)              return <Navigate to="/login" replace />;
  if (user.role !== 'admin') return <Navigate to="/" replace />;
  return children;
}
